<template>
  <div>
    <v-subheader v-if="title!==null">{{title}}</v-subheader>
    <!-- default lg for specific used -->
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <template v-if="items!==null">
          <template v-for="(item, x) in items">
            <v-flex lg2 md4 xs6 :key='x' v-if="accessControl(item.access)">
              <v-card :class=" key===x ? 'quoteCard cardActive' : 'quoteCard'" @click.native="doProceed(item.name, x, item.params)">
                <v-layout fill-height column justify-center align-center>
                  <v-icon>{{item.icon}}</v-icon>
                  <span>{{item.text}}</span>
                </v-layout>
              </v-card>
            </v-flex>
          </template>
        </template>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
/**
 * This file is use for component CardMenu template.
 * title: Description of CardMenu
 * items: must be Array of Object format on below
 * text: Displays Card title on screen
 * icon: Custom icon for menu
 * name: must be unique, lower-case, no-space (primary-key and must be same as route name) - try not to change it for no reason
 * params: Object, emit params control.
 * access: access control. (Pivileges control)
 * e.g: items: { { text: 'Title Card', icon: 'mdi-cash', name: 'claimRegister', params: {}, access: ['claimQuery','claimReview'], default: true/false } }
 * emit control
 * only can contain one default true
 * @cardReturn for item params must used a methods to retrive data
 * throw error DataType undefined
 */
import { mapGetters } from 'vuex'
export default {
  data() {
    // hover defined
    return {
      key: undefined
    }
  },
  props: {
    title: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: null
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  methods: {
    async doProceed(routeLink, activeKey, params) {
      this.key = activeKey
      if (routeLink !== null && typeof routeLink !== 'undefined' && routeLink !== '') {
        this.$router.push({ name: routeLink })
      } else if (params !== null && typeof params !== 'undefined' && params !== '') {
        this.$emit('cardReturn', params)
      }
      // Disable Deselect and always trigger on click
      // if (this.key !== activeKey) {
      //   this.key = activeKey
      //   if (routeLink !== null && typeof routeLink !== 'undefined' && routeLink !== '') {
      //     this.$router.push({ name: routeLink })
      //   } else if (params !== null && typeof params !== 'undefined' && params !== '') {
      //     this.$emit('cardReturn', params)
      //   }
      // } else {
      //   this.key = undefined
      //   this.$emit('cardReturn', undefined)
      // }
    },
    accessControl(privileges) {
      if (typeof privileges !== 'undefined' && privileges !== null && privileges !== '') {
        return this.checkAccess(privileges)
      } else {
        return true
      }
    }
  },
  mounted() {
    // default highlight
    this.items.findIndex((element, index) => {
      if (element.default === true) {
        this.key = index
        this.$emit('cardReturn', element.params)
      }
    })
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/agency.scss";
</style>
